"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    const prevalidateFilesRequest = (folderId, ids, type) => ({
        type: _ActionTypes.PREVALIDATE_FILES_REQUEST,
        payload: {
            folderId,
            ids,
            type
        }
    });
    const prevalidateFilesSuccess = (valid, files, reimportedUuids = [], colorMetaId) => ({
        type: _ActionTypes.PREVALIDATE_FILES_SUCCESS,
        payload: {
            valid,
            files,
            reimportedUuids,
            colorMetaId
        }
    });
    const prevalidateFilesFailure = (error) => ({
        type: _ActionTypes.PREVALIDATE_FILES_FAILURE,
        payload: error
    });
    const prevalidateImportedFilesRequest = (folderId, ids, type) => ({
        type: _ActionTypes.PREVALIDATE_IMPORTED_FILES_REQUEST,
        payload: {
            folderId,
            ids,
            type
        }
    });
    const prevalidateImportedFilesSuccess = (valid, files, reimportedUuids = [], colorMetaId) => ({
        type: _ActionTypes.PREVALIDATE_IMPORTED_FILES_SUCCESS,
        payload: {
            valid,
            files,
            reimportedUuids,
            colorMetaId
        }
    });
    const prevalidateImportedFilesFailure = (error) => ({
        type: _ActionTypes.PREVALIDATE_IMPORTED_FILES_FAILURE,
        payload: error
    });
    const selectFiles = (uuids) => ({
        type: _ActionTypes.SELECT_FILES,
        payload: {
            uuids
        }
    });
    const unselectFiles = (uuids) => ({
        type: _ActionTypes.UNSELECT_FILES,
        payload: {
            uuids
        }
    });
    const changeColor = (file, color) => ({
        type: _ActionTypes.CHANGE_COLOR,
        payload: {
            file,
            color
        }
    });
    const removeFile = (uuids) => ({
        type: _ActionTypes.REMOVE_FILE,
        payload: {
            uuids
        }
    });
    const browse = (browse) => ({
        type: _ActionTypes.BROWSE,
        payload: {
            browse: browse
        }
    });
    const restoreFile = () => ({
        type: _ActionTypes.RESTORE_FILE
    });
    return {
        prevalidateFilesRequest,
        prevalidateFilesSuccess,
        prevalidateFilesFailure,
        prevalidateImportedFilesRequest,
        prevalidateImportedFilesSuccess,
        prevalidateImportedFilesFailure,
        selectFiles,
        unselectFiles,
        changeColor,
        removeFile,
        browse,
        restoreFile
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map